export default [
  [`Размер`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `46`, `48`, `50`, `52`, `54`],
  [`Грудь`, `100-104`, `104-108`, `108-112`, `112-116`, `116-120`],
  [`Длина`, `70-72`, `72-74`, `74-76`, `78-80`, `80-82`]
];
